import { MultipleChoiceExamStatics } from '../../../../../../../store/workspace/types';
import { ChevronDownIcon } from '../../../../../../../assets/icons';
import DropDown from '../../../../../../../components/DropDown';
import { QuestionChoices, QuestionText } from '../../../../components/QuestionContent';
import EmptyState from '../../../../components/EmptyState';
import { QUESTION_LEVEL_FILTERS, QUESTION_TYPE_FILTERS } from '../../../../constants';
import { useFilteredQuestions } from '../../../../hooks/useFilteredQuestions';
import { useExpandableRows } from '../../../../hooks/useExpandableRows';
import styles from './style.module.scss';

interface Props {
    examData: MultipleChoiceExamStatics | null;
};

export default function MultipleChoiceExamSheet({ examData }: Props) {
    const { isExpanded, toggleRow } = useExpandableRows<number>();
    const {
        questions,
        questionType,
        questionLevel,
        setQuestionType,
        setQuestionLevel,
    } = useFilteredQuestions(examData);

    if (!examData) {
        return (
            <div className={styles.wrapper}>
                <EmptyState className={styles.empty_state} />
            </div>
        );
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <div className={styles.header_top}>
                    <span className={styles.header_top_title}>{examData.exam?.jobTitle}</span>
                    <div className={styles.header_top_actions}>
                        <DropDown
                            idKey='id'
                            titleKey='title'
                            label='Questions level'
                            setItem={setQuestionLevel}
                            selectedItem={questionLevel}
                            dropDownList={QUESTION_LEVEL_FILTERS}
                            containerClassName={styles.header_top_actions_dropdown}
                        />
                        <DropDown
                            idKey='id'
                            titleKey='title'
                            label='Questions type'
                            setItem={setQuestionType}
                            selectedItem={questionType}
                            dropDownList={QUESTION_TYPE_FILTERS}
                            containerClassName={styles.header_top_actions_dropdown}
                        />
                    </div>
                </div>
                <div className={styles.header_bottom}>
                    <span className={styles.header_bottom_item}>
                        Question Quantities : {examData.exam?.n_questions}
                    </span>
                    <span className={styles.header_bottom_item}>
                        Exam Time : {examData.exam?.time}'
                    </span>
                </div>
            </div>

            <div className={styles.table}>
                <table>
                    <thead>
                        <tr>
                            <th>Questions & Answers</th>
                            <th>Level</th>
                            <th>Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {questions.map(({ choices, answer, question, level, type }, position) => <tr key={position}>
                            <td>
                                <QuestionText
                                    styles={styles}
                                    question={question}
                                    codeBlock='always'
                                    prefix={`${position + 1} - `}
                                />
                                <QuestionChoices styles={styles} choices={choices} answer={answer} />
                            </td>
                            <td style={{ textTransform: 'capitalize' }}>{level}</td>
                            <td style={{ textTransform: 'capitalize' }}>{type}</td>
                        </tr>)}
                    </tbody>
                </table>
            </div>

            <div className={styles.mobile_list}>
                {questions.map(({ choices, answer, question, level, type }, position) => <div
                    key={position}
                    className={styles.card}
                    onClick={() => toggleRow(position)}
                >
                    <div className={styles.card_header}>
                        <span>Question {position + 1}</span>
                        <ChevronDownIcon style={{ transform: isExpanded(position) ? 'rotate(180deg)' : 'none' }} />
                    </div>

                    {isExpanded(position) && <div className={styles.card_body}>
                        <div className={styles.card_body_section}>
                            <div className={styles.card_body_section_content}>
                                <QuestionText styles={styles} question={question} codeBlock='auto' />
                                <QuestionChoices styles={styles} choices={choices} answer={answer} />
                            </div>
                        </div>
                        <div className={styles.card_body_section}>
                            <div className={styles.card_body_section_title}>
                                <span>Level</span>
                                <span>{level}</span>
                            </div>
                        </div>
                        <div className={styles.card_body_section}>
                            <div className={styles.card_body_section_title}>
                                <span>Type</span>
                                <span>{type}</span>
                            </div>
                        </div>
                    </div>}
                </div>)}
            </div>
        </div>
    );
};
